import React, { useContext } from 'react';
import { KibSheet } from '@chewy/kib-overlays-react';
import { KibIngressCard } from '@chewy/kib-cards-react';
import { PetAvatar, AvatarTypes, AvatarSizes } from '@chewy/pet-profile-pet-avatar';
import { PetInterface } from 'types/pet';
import AnalyticsContext from '../../context/AnalyticsContext';
import { ApiPetProfileStatusReasonEnum } from '../../api/generated-client/PetProfile-Service-A.v1/models';
import { getPetMemorialPath } from '../../util/config';
import './memorial-pet-sheet.scss';

export default function MemorialPetSheet({
  pets,
  showPetSheet,
  setShowPetSheet,
}: {
  pets: PetInterface[];
  showPetSheet: boolean;
  setShowPetSheet: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const petSheetTitle = 'Memorialized Profiles';
  const analytics = useContext(AnalyticsContext);

  const handlePetCardSelect = (pet: PetInterface) => {
    analytics.trackRainbow({
      name: 'pet profile memorial - clicked',
      category: 'pet-profile-memorial',
      action: 'click',
      label: 'pet_profle_memorial_select',
    });
    window.location.href = getPetMemorialPath(pet.id);
  };

  const getStrokeType = (statusReason: ApiPetProfileStatusReasonEnum): AvatarTypes =>
    statusReason === ApiPetProfileStatusReasonEnum.Deceased
      ? AvatarTypes.MemorialDeceased
      : AvatarTypes.MemorialOther;

  return (
    <KibSheet
      open={showPetSheet}
      onClose={() => {
        setShowPetSheet(false);
      }}
      bottom
      title={petSheetTitle}
      size="large"
      data-testid="memorial-pet-sheet"
      className="memorial-pet-sheet"
    >
      {pets.map((pet, index) => (
        <KibIngressCard
          key={index}
          image={
            <PetAvatar
              className="pet-avatar-button__image"
              data-testid="memorial-pet-avatar"
              alt="pet avatar"
              size={AvatarSizes.SMALL}
              src={pet.avatarUrl}
              strokeType={
                pet.statusReason ? getStrokeType(pet.statusReason) : AvatarTypes.MemorialOther
              }
            />
          }
          title={pet.name}
          className="memorial-pet-sheet__cards"
          onClick={() => {
            handlePetCardSelect(pet);
          }}
        />
      ))}
    </KibSheet>
  );
}
